import api from '@/api/index.js'

const distributor_bulk_transactions = {
    state: {
        loading: false,
        forceCancelResponse: null,
        error: null
    },


    mutations: {
        DISTRIBUTORS_TRANSACTIONS_FORCE_CANCEL_LOADING: (state, loading) => {
            state.loading = loading;
        },
        DISTRIBUTORS_TRANSACTIONS_FORCE_CANCEL: (state, forceCancelResponse) => {
            state.forceCancelResponse = forceCancelResponse;
            state.loading = false;
        },
        DISTRIBUTORS_TRANSACTIONS_FORCE_CANCEL_ERROR: (state, error) => {
            state.error = error;
        }
    },

    actions: {
        ForceDistributorsTransactionsCancel({commit}, query) {
            let reqQueryStr = '';
            if (query.period.year) {
                reqQueryStr = `year=${query.period.year}&month=${query.period.month}`
            } else {
                reqQueryStr = `from=${query.period.from}&to=${query.period.to}`
            }

            commit('DISTRIBUTORS_TRANSACTIONS_FORCE_CANCEL_ERROR', null)
            commit('DISTRIBUTORS_TRANSACTIONS_FORCE_CANCEL', null)
            commit('DISTRIBUTORS_TRANSACTIONS_FORCE_CANCEL_LOADING', true)
            return api.delete(`distributors/${query.distributor_id}/pos-transactions?` + reqQueryStr)
                .then((forceCancelResponse) => {
                    commit('DISTRIBUTORS_SUMMARY_UPDATE_REPORT', {
                        distributor_id: query.distributor_id,
                        force_cancel_count: forceCancelResponse.body.force_cancel_count
                    });
                    commit('DISTRIBUTORS_TRANSACTIONS_FORCE_CANCEL_LOADING', false)
                })
                .catch((error) => {
                    commit('DISTRIBUTORS_TRANSACTIONS_FORCE_CANCEL_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
                    commit('DISTRIBUTORS_TRANSACTIONS_FORCE_CANCEL_LOADING', false)
                })
        }
    },
}

export default distributor_bulk_transactions
